module.exports = __webpack_public_path__ + "img/img_tipo_cem_d.6cb801ab.png";